import React from 'react';
import { RouteComponentProps } from 'react-router';
import { WithdrawCreateContainer } from '../../epic/withdraw-create';

export const Page: React.FC<RouteComponentProps> = () => {
  return <WithdrawCreateContainer />;
};
